import { Component, ViewChild } from '@angular/core';
import {IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController } from 'ionic-angular';
import {EnquiryFormPage} from "../enquiry-form/enquiry-form";
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { SocialSharing } from '@ionic-native/social-sharing';
import {AddAppointmentPage} from "../add-appointment/add-appointment";
import {ListDataModelPage} from "../list-data-model/list-data-model";
import {DataCallLogPage} from "../data-call-log/data-call-log";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {SubStatusHistoryPage} from "../sub-status-history/sub-status-history";

@Component({
  selector: 'page-appointments',
  templateUrl: 'appointments.html',
})
export class AppointmentsPage {

  FUserId:any;
  UserRights:any;
  SchoolData = {};
  TypeData = {};
  School = 'All';
  CommonTypeId = 'Web_Enquiry';
  FilterOption = 'Date';
  Date: any;
  DisplayDate = "";
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  datanotfound:any;
  AptStatus='Open';
  AptStatusData={};
  Reasons:any;
  emp:any;
  DataSearch: any;
  AppointmentData=[];
  AppointmentData1: any;

  page=1;
  IsSearch=0;

  OpenCount:any;
  TodayCount:any;
  TomorrowCount:any;
  PastCount:any;
  CancelledCount:any;

  SubStatus:any;
  SubStatusItem:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public modalCtrl: ModalController,public alertCtrl: AlertController,
              private contacts: Contacts,
              private socialSharing: SocialSharing,
              public iab: InAppBrowser) {
    this.platform.ready().then(() => {
       Promise.all([this.storage.get('LoginData')]).then(values => {
         this.Date = new Date();
         this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear();
         this.Date = this.Date.toISOString();

         this.SchoolData = {
           "All": 0,
           "GWW": 2,
           "GWE": 3,
           "GEIS": 1
         };

         this.AptStatusData = {
           "Open": 1,
           "Cancelled": 2,
           "Today": 3,
           "Tomorrow": 4,
           "Past": 5,
         };


         this.FUserId = values[0]['FUserId'];
        console.log(this.FUserId);
        this.get_user_rights(this.FUserId);
        this.getReasons();

      });
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppointmentsPage');
  }

  open_enquiry_form(){
    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage);
    EnquiryModel.onDidDismiss(data => {
      console.log(data);

      this.loadCountvalues(this.SchoolData[this.School]);
      this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
      this.presentToast(data);
    });
    EnquiryModel.present();
  }

  presentToast(msg){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  get_user_rights(FUserId) {
    this.service.httpcall('web_service/get_users_rights?FUserId=' + FUserId).subscribe(data => {
      console.log(data['RightsData']);
      this.UserRights = data['RightsData'];
      if (this.UserRights != undefined) {
        console.log(this.School)
        this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
        this.loadCountvalues(this.SchoolData[this.School]);
      }
    })
  }
  active_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.CommonTypeId = 'Web_Enquiry';
    this.AppointmentData=[];
    this.page=1;
    this.IsSearch=0;
    this.DataSearch=null;
    this.AptStatusactive_tab(this.AptStatus);
    //this.loadvalues(this.SchoolData[this.School], this.FUserId);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  AptStatusactive_tab(tab) {
    console.log(tab);
    this.AptStatus = tab;
    this.CommonTypeId = 'Web_Enquiry';
    this.AppointmentData=[];
    this.page=1;
    this.IsSearch=0;
    this.DataSearch=null;
    this.loadCountvalues(this.SchoolData[this.School]);
    this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  loadvalues(FSchoolId, FUserId,AptStatus,page) {
    // let loading = this.loadingCtrl.create({
    //   content: 'Loading'
    // });
    // loading.present();
    // setTimeout(() => {
    //   loading.dismiss();
    // }, 5000);
    // this.AppointmentData = [];
    // this.AppointmentData =null;
    this.datanotfound=null;
    console.log("FSchoolId", FSchoolId);
    this.service.httpcall('web_service/get_appointment_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&AptStatus='+AptStatus+'&page='+page).subscribe(data => {
      // loading.dismiss();
      console.log(data);
      if(data['response']=="success"){
        this.datanotfound=null;
        // this.AppointmentData = data['data'];
        for (let i = 0; i < data['data'].length; i++) {
          this.AppointmentData.push( data['data'][i] );
        }
        // this.AppointmentData1 =  data['data'];
        // this.AppointmentData = this.AppointmentData1;
      }else{
        this.datanotfound=data['error_description'];
      }

    })
  }

  loadCountvalues(FSchoolId) {

    console.log("FSchoolId", FSchoolId);
    this.service.httpcall('web_service/get_appointment_count?FSchoolId=' + FSchoolId).subscribe(data => {
      // loading.dismiss();
      console.log(data);
      this.OpenCount=data['OpenCount'];
      this.TodayCount=data['TodayCount'];
      this.TomorrowCount=data['TomorrowCount'];
      this.PastCount=data['PastCount'];
      this.CancelledCount=data['CancelledCount']

    })
  }

  doInfinite(infiniteScroll) {
    if(this.IsSearch==0){
      console.log('Begin async operation');

      setTimeout(() => {
        // for (let i = 0; i < 30; i++) {
        //   this.items.push( this.items.length );
        // }
        this.page=this.page + 1;
        console.log("page number ", this.page);
        this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);

        console.log('Async operation has ended');
        infiniteScroll.complete();
      }, 500);
    }else{
      console.log('Begin async operation');

      setTimeout(() => {
        // for (let i = 0; i < 30; i++) {
        console.log('Async operation has ended');
        infiniteScroll.complete();
      }, 500);
    }

  }

  enquiry_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            // window.location.href = 'tel:'  + data;

            let loading = this.loadingCtrl.create({
              content: 'Loading',
              enableBackdropDismiss:false
            });
            loading.present();


            var formdata=new FormData();
            formdata.append("FWebEnquiryId", enquirydata.FWebEnquiryId);
            formdata.append("AddedBy",this.FUserId);
            formdata.append("CallTo",data);
            formdata.append("CallType","2");
            formdata.append("FileName","text");
            // formdata.append("CallFor",this.CallFor);


            this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
              console.log(resdata);
              if (resdata['response'] == 'success') {
                var LogId=resdata['LogId'];
                if(loading)
                  loading.dismiss();
                loading = undefined;
                var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
                const browser = this.iab.create(link,'_system',{location:'no'});
                window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
              } else {
                if(loading)
                  loading.dismiss();
                loading = undefined;
              }
            },(err)=>{
              if(loading)
                loading.dismiss();
              loading = undefined;
            });

          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();
  }
  go_to_call_logs(item){
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage,{data:item,Tab:2});
    // AppointmentModel.onDidDismiss(data => {
    //   console.log(data);
    // });
    Call_logs_model.present();
  }
  whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'whatsapp://send?phone=+91' + data;
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();


  }
  msg_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'sms:'  + data;
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();
  }
  msg_Group(item){

    this.socialSharing.shareViaWhatsApp(item.SendWhatsAppGroupMsg, null, null);

  }
  send_whatsapp(item) {

    let myAlert = this.alertCtrl.create({
      title: 'Send WhatsApp',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'WhatsApp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            this.socialSharing.shareViaWhatsAppToReceiver('+91'+data, "", null, item.SendMsg);

          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();


  }
  send_msg(item) {

    let myAlert = this.alertCtrl.create({
      title: 'Send Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            this.socialSharing.shareViaSMS(item.SendMsg,'+91'+data);

          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();


  }
  rescheduleApmt(item){
    let AppointmentModel = this.modalCtrl.create(AddAppointmentPage,{aptData:item});
    AppointmentModel.onDidDismiss(data => {
      console.log(data);
      this.AppointmentData=[];
      this.page=1;
      this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
      this.presentToast(data);
    });
    AppointmentModel.present();
  }
  cancelApmt(item){
    let myAlert = this.alertCtrl.create({
      title: 'Cancel Appointment',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: (data) => {
            console.log('clicked');
            console.log(data);

            this.service.httpcall('web_service/cancelled_appointments?AppointmentId=' + item.Id+"&ReasonId="+data+"&Bit=0&CancelledBy="+this.FUserId ).subscribe(data => {
              console.log(data);
              if(data['response']=="success"){
                this.presentToast(data['success_message']);
                this.AppointmentData=[];
                this.page=1;
                this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
              }else{
                this.presentToast(data['error_description']);
              }

            },(error2 => {
              this.presentToast("Timeout!");
            }))

          }
        }
      ]
    });

    for(var i = 0; i < this.Reasons.length; i++) {
      this.emp=this.Reasons[i];
      var edata=this.emp.Name;
      myAlert.addInput({
        type:'radio',
        label: edata,
        value: this.emp.Id
      })
    }


    /*myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })*/

    myAlert.present();
  }
  getReasons(){
    this.Reasons=null;
    this.service.httpcall('web_service/get_master_appointment_cancellation_reasons?' ).subscribe(data => {
      console.log("getReasons",data);
      this.Reasons=data;

    },(error2 => {
      this.presentToast("Timeout!");
    }))
  }
  addSibling(item){
    let AppointmentModel = this.modalCtrl.create(AddAppointmentPage,{siblingdata:item,sibling:1});
    AppointmentModel.onDidDismiss(data => {
      console.log(data);
      this.AppointmentData=[];
      this.page=1;
      this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
      this.presentToast(data);
    });
    AppointmentModel.present();
  }
  edit_enquiry(item){
    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage,{editData:item,IsAppointment:1});
    EnquiryModel.onDidDismiss(data => {
      console.log(data);
      this.AppointmentData=[];
      this.page=1;
      this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
      this.presentToast(data);
    });
    EnquiryModel.present();
  }
  get_enquiry_log(item){

    this.service.httpcall('web_service/get_web_enquiry_by_school_id?FWebEnquiryId=' + item.FWebEnquiryId).subscribe(data => {

      console.log(data);
      if(data['response']=="success"){
        let ListModel = this.modalCtrl.create(ListDataModelPage,{data:data['data'],title:"History"});
        ListModel .onDidDismiss(data => {
          console.log(data);
          this.presentToast(data);
        });
        ListModel.present();
      }else{
        this.presentToast(data['error_description']);
      }

    })


  }
  add_SubStatus(item){


    this.SubStatus=null;
    this.SubStatusItem=null;
    this.service.httpcall('web_service/get_master_enquiry_substatus?params[FStatusId]='+item.Status).subscribe(data => {
      console.log("getReasons",data);
      if(data['response']=="success"){
        this.SubStatus=data['data'];
        console.log(this.SubStatus);
        let myAlert = this.alertCtrl.create({
          title: 'Set SubStatus',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Confirm',
              handler: (data) => {
                console.log('clicked');
                console.log(data);

                this.service.httpcall('web_service/add_subStatus_On_webEnquiryId?FStatusId=' + item.Status+'&FWebEnquiryId=' + item.FWebEnquiryId+'&FUserId=' + this.FUserId+'&FSubStatusId=' + data).subscribe(data => {
                  console.log(data);
                  if(data['response']=="success"){
                    this.presentToast(data['success_message']);
                    this.AppointmentData=[];
                    this.page=1;
                    this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);
                  }else{
                    this.presentToast(data['error_description']);
                  }

                },(error2 => {
                  this.presentToast("Timeout!");
                }))

              }
            }
          ]
        });
        for(var i = 0; i < this.SubStatus.length; i++) {
          this.SubStatusItem=this.SubStatus[i];
          var edata=this.SubStatusItem.SubStatusName;
          console.log(edata);
          myAlert.addInput({
            type:'radio',
            label: edata,
            value:  this.SubStatusItem.Id
          })
        }

        myAlert.present();
      }else{
        this.presentToast(data['error_description']);

      }

    },(error2 => {
      this.presentToast("Timeout!");

    }))


  }
  go_to_SubStatus_hist(item){
    let SubStatusHistory = this.modalCtrl.create(SubStatusHistoryPage,{FWebEnquiryId:item.FWebEnquiryId});
    SubStatusHistory.onDidDismiss(data => {
      console.log(data);
    });
    SubStatusHistory.present();
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.AppointmentData=[];
    this.page=1;
    this.loadvalues(this.SchoolData[this.School], this.FUserId,this.AptStatusData[this.AptStatus],this.page);

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }
  searchData(ev: any) {
    // Reset items back to all of the items
    this.AppointmentData = this.AppointmentData1;
    // set val to the value of the searchbar
    let val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.AppointmentData = this.AppointmentData.filter((item) => {
        return (item.SendWhatsAppGroupMsg.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/appointments/appointments.ts